import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { ArtifactType } from '../contexts/ArtifactContext/artifact.lib';
import { useActiveArtifactType } from './useActiveArtifactType';

/**
 * Whether the school workflow is the active tab: the same magic chat, narrowed
 * to the one job parents and teachers come for, turning a school PDF into
 * calendar events.
 *
 * Gated on the flag as well as the tab so a stale or shared `?mode=schools`
 * falls back to ordinary magic rather than rendering a workflow that is off.
 * Reads the type from the URL rather than ArtifactContext so it works above the
 * provider too (the hero renders outside it in the job experience).
 */
export const useIsSchoolsMode = () => {
  const { artifactType } = useActiveArtifactType();
  const { value: isEnabled, loading } = useFeatureFlag('magicSchoolsEnabled');

  return {
    isSchoolsMode: isEnabled && artifactType === ArtifactType.Schools,
    loading,
  };
};
